/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapMutations } from 'vuex';

export default {
  name: 'FlashCardSheet',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_modalCardType: 'modalCardType',
      ms_flashCardList: 'flashCardList',
      ms_idxCard: 'idxCard',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    toggleSheet() {
      this.mm_SET_MODAL_CARD_TYPE('');
    },

    gotoSheetCard(idxCard) {
      this.$emit('goto-sheet-card', idxCard);
    },
  },
};
